// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"d98f98ad","455":"b10d64d3","977":"6b4a070e"}[chunkId] + ".chunk.js";
};